module.exports = __webpack_public_path__ + "img/logo-icon-blue.3ab0461d.svg";